import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import '../../styles/common/Unauthorized.css';

const Unauthorized = () => {
    const { user, logout } = useAuth();

    const getCorrectDashboardLink = () => {
        return user?.role === 'user' ? '/user/dashboard' : '/dashboard';
    };

    return (
        <div className="unauthorized-container">
            <div className="unauthorized-box">
                <div className="error-icon">🚫</div>
                <h1>Access Denied</h1>
                <p>You don't have permission to access this page.</p>
                
                <div className="user-info">
                    <p>Logged in as: <strong>{user?.username}</strong></p>
                    <p>Role: <span className="role-badge">{user?.role?.replace('_', ' ') || 'Unknown'}</span></p>
                </div>
                
                <div className="action-buttons">
                    <Link to={getCorrectDashboardLink()} className="btn btn-primary">
                        Go to {user?.role === 'user' ? 'User' : 'Admin'} Dashboard
                    </Link>
                    
                    <button onClick={logout} className="btn btn-secondary">
                        Logout
                    </button>
                </div>
            </div>
        </div>
    );
};

export default Unauthorized;